/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

export class ApprovalRequest {


    public vendorId: number;
    public approvalFlag: number;

     constructor(approvalRequest: any) {
         this.vendorId = approvalRequest.vendorId || '';
         this.approvalFlag = approvalRequest.approvalFlag || 1;
     }
 }
